export const flattenObject = obj => {
  return Object.assign(
    {},
    ...(function _flatten(object, prefix) {
      return [].concat(
        ...Object.keys(object).map(key => {
          let newKey = key;
          if (prefix) {
            newKey = prefix + '.' + newKey;
          }

          if (object[key] && typeof object[key] === 'object') {
            return _flatten(object[key], key);
          } else {
            return { [newKey]: object[key] };
          }
        })
      );
    })(obj, null)
  );
};

export const flattenObjectArray = arr => {
  const flattened = [];
  for (let e of arr) {
    flattened.push(flattenObject(e));
  }

  return flattened;
};
